<template>
  <v-dialog v-model="show"
            :width="dialogWidth"
            scrollable
            persistent
  >
    <v-sheet>
      <v-toolbar>
        <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>

        <v-spacer />

        <v-btn icon @click="show = false">
          <v-icon large>
            $close
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider />

      <v-card-text>
        <v-sheet v-if="!cropperImageChanged && computedImage"
                 class="d-flex justify-center"
        >
          <v-sheet :width="cropperOptions.width || 720">
            <v-img :src="imageViewUrl(computedImage)"
                   :aspect-ratio="cropperOptions.aspectRatio || 16/9"
                   :class="{
                     'rounded-circle': cropperOptions.component === 'circle-stencil'
                   }"
                   contain
            />
          </v-sheet>
        </v-sheet>

        <vue-advanced-cropper ref="imageCropper"
                              :cropper-options="cropperOptions"
                              :preview-options="previewOptions"
                              @cropped-image="croppedImage"
                              @cropper-image-changed="hidePrevImage"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn color="secondary" depressed @click="show = false">
          취소
        </v-btn>
        <v-btn color="primary" depressed @click="cropImage">
          저장
        </v-btn>
      </v-card-actions>
    </v-sheet>
  </v-dialog>
</template>

<script>
import VueAdvancedCropper from '@/components/common/VueAdvancedCropper';
import { imageViewUrl } from '@/assets/commonFunctions';

export default {
  name: 'CropperDialog',
  components: { VueAdvancedCropper },
  props: {
    value: { type: Boolean, default: false },
    dialogTitle: { type: String, default: '이미지 crop' },
    dialogWidth: { type: Number, default: 1280 },
    cropperOptions: { type: Object, default: () => ({}) },
    previewOptions: { type: Object, default: () => ({}) },
    imagePath: { type: String, default: null },
  },
  data: () => ({
    image: null,
    cropperImageChanged: false,
  }),
  computed: {
    show: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      },
    },
    computedImage () {
      return this.imagePath;
    },
  },
  methods: {
    imageViewUrl,
    cropImage () {
      this.$refs.imageCropper.crop();
    },
    croppedImage (image) {
      this.image = image || this.computedImage;
      this.$emit('cropped-image', this.image);
    },
    hidePrevImage () {
      this.cropperImageChanged = true;
    },
  },
};
</script>

<style scoped>

</style>
